import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import useSWR from "swr";
import {
  parseClientError,
  swrFetcher,
} from "../../../../../../../libs/api/Endpoints";
import s from "./Message.module.scss";
import { message, Skeleton } from "antd";

import { ApplicationMessageDetails } from "../../../../../../../libs/Utils/Types/User";
import { useParams } from "react-router-dom";
import { normalizeEmailHTML } from "../../../../../../../libs/Utils/customHooks";
// Define the shape of the state

function MessageDetails() {
  const { msgId } = useParams();
  const token = UseAuthToken();
  // Destructure the state with default values to avoid issues if the state is undefined

  const {
    data: emailDetails,
    isLoading,
    error,
  } = useSWR<{ data: ApplicationMessageDetails }, any, any>(
    token ? [`api/admin/app-messages/${msgId}`, token] : null,
    swrFetcher,
    {
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );

  if (error) {
    const e = parseClientError(error);
    message.error(e.message || "Message failed to load");
  }
  return (
    <div className={s.mainWrapper}>
      <div className={s.wrapper}>
        {isLoading || error ? (
          <Skeleton.Node
            active={isLoading || error}
            style={{ height: "40px", width: "150px" }}
          />
        ) : (
          <div className={s.msgHeader}>
            <h2 className={s.title}>{emailDetails?.data.title}</h2>
          </div>
        )}
        <div className={s.msg}>
          {isLoading || error ? (
            <Skeleton.Button
              active={isLoading || error}
              size={"default"}
              shape={"square"}
              block={true}
              style={{ height: "161px" }}
            />
          ) : (
            <table className={s.msgTitle}>
              {emailDetails?.data.title && (
                <tr>
                  <td className={s.emailTitles}>Email subject</td>
                  <td className={s.subtitles}>
                    {emailDetails?.data.title || "Not found"}
                  </td>
                </tr>
              )}
              <tr>
                <td className={s.emailTitles}>Audience</td>
                <td className={s.subtitles}>
                  {emailDetails?.data.audience || "Not found"}
                </td>
              </tr>
              <tr>
                <td className={s.emailTitles}>Number of users</td>
                <td className={s.subtitles}>
                  {emailDetails?.data.stats.total || 0}
                </td>
              </tr>
            </table>
          )}

          <div>
            <div className={s.msgBodyWrapper}>
              <h3>Message</h3>
            </div>
            {isLoading || !emailDetails?.data.body ? (
              <Skeleton.Button
                active={true}
                size={"default"}
                shape={"square"}
                block={true}
                style={{ height: "449px" }}
              />
            ) : (
              <div className={s.msgBody}>
                <div
                  className={s.sandbox}
                  dangerouslySetInnerHTML={{
                    __html: normalizeEmailHTML(emailDetails?.data.body),
                  }}
                ></div>
              </div>
            )}
            {/* Render rich text */}
          </div>
        </div>
      </div>
    </div>
  );
}
export default MessageDetails;
